import React, { useState, useEffect } from 'react';
import { Auth }             from 'aws-amplify';
import { connect }          from 'react-redux';

import queryString          from 'query-string';

import { setSnackbar } from '../../../redux/actions/snackbar';
import FormValidator  from '../../../modules/FormValidator';

import AuthForm   from '../../../components/AuthForm';
import AuthHeader from '../../../components/AuthHeader';
import Button     from '../../../components/Button';
import Input      from '../../../components/Input';

import useStyles from './styles';
import { Typography } from '@material-ui/core';

const Confirm = (props) => {
  const { setSnackbar } = props;
  const classes = useStyles();
  
  const [email] = useState(queryString.parse(props.location.search).email);
  const [code, setCode] = useState({value: '', valid: true});
  const [loading, setLoading] = useState(false);

  let refs = {
    code: React.createRef()
  }

  useEffect(() => {
    if(!email) props.history.replace('/login');
  }, [email, props.history])

  async function handleConfirm(e) {
    e.preventDefault();

    const invalidFields = FormValidator(refs);

    if (invalidFields.length > 0) {
      return handleError(invalidFields[0].message);
    }

    setLoading(true);
    try {
      await Auth.confirmSignUp(email, code.value);
      setSnackbar('Account successfully confirmed! Please login to continue.');
      props.history.push('/');
    }
    catch(error) {
      handleError(error);
    }
  }

  function handleError(error) {
    if (typeof props.onError === 'function') {
      props.onError(error);
    }
  }

  return(
    <AuthForm className={classes.root} onSubmit={handleConfirm}>

      <AuthHeader />

      <div className={classes.helpText}>
        <Typography variant="body2" component={"p"}>
          Please check your email for a verification code
        </Typography>
      </div>

      <Input
        id='code'
        ref={(el) => refs.code = el}
        errorMessage="A code is required"
        validator={() => code.value.length > 0}
        marginBottom={24}
        label='Confirmation Code'
        onChange={e => setCode({value: e.target.value, valid: true})}
        value={code.value}
        error={!code.valid} />

      <input type="submit" style={{ display: 'none' }} />

      <Button
        color="primary"
        loading={loading}
        fullWidth={true}
        onClick={handleConfirm}
        size="large"
        text={'Confirm Account'}
        variant="contained"
      />

    </AuthForm>
  );
}

const mapStateToProps = ({ user }) => ({ user });

export default connect(mapStateToProps, { setSnackbar })(Confirm);